import {createContext, Dispatch} from 'react'
import {FleetScoreOverTimeState} from './types/fleet-score-over-time-state'
import {AllActions} from './state/actions'
import {DEFAULT_FLEET_SCORE_OVER_TIME_STATE} from './types/default-fleet-score-over-time-state'

export const fleetScoreOverTimeContext = createContext<{
    state: FleetScoreOverTimeState
    dispatch: Dispatch<AllActions> | undefined
}>({state: DEFAULT_FLEET_SCORE_OVER_TIME_STATE, dispatch: undefined})
